<script>
    import MainContainer from '@/components/container/MainContainer.vue';
    import LeftPanel from '@/components/container/LeftPanel.vue';
    import RightContainer from '@/components/container/RightContainer.vue';

    import ButtonReturn from '@/components/left-panel/unique-buttons/ButtonReturn.vue';

    import SettingContainer from '@/components/page-setting/SettingContainer.vue';
    import SettingFileEdit from '@/components/page-setting/SettingFileEdit.vue';
    import SettingMainColor from '@/components/page-setting/SettingMainColor.vue';


    export default {
        components: {
            MainContainer: MainContainer,
            LeftPanel: LeftPanel,
            RightContainer: RightContainer,

            ButtonReturn: ButtonReturn,

            SettingContainer: SettingContainer,
            SettingFileEdit: SettingFileEdit,
            SettingMainColor: SettingMainColor,
        }
    }
</script>


<template>
    <MainContainer>
        <LeftPanel>
            <ButtonReturn />
        </LeftPanel>
        <RightContainer>
            <SettingContainer>
                <SettingFileEdit />
                <SettingMainColor />
            </SettingContainer>
        </RightContainer>
    </MainContainer>
</template>